import { of as observableOf, Observable, empty } from 'rxjs';
import { ajax, AjaxResponse } from 'rxjs/ajax';
import { map, switchMap, catchError, debounceTime } from 'rxjs/operators';
import { RootState } from './index';
import { Action } from 'redux';
import { ActionsObservable, StateObservable } from 'redux-observable';
import Filter from '../sections/Filter';

export const UPDATE_FORM = "LOGIN_UPDATE_FORM";
export const TOGGLE_TIMEOUT = "LOGIN_TOGGLE_TIMEOUT";
export const TOGGLE_CHECKOUT = "LOGIN_TOGGLE_CHECKOUT";
export const TOGGLE_DOWNLOAD = "LOGIN_TOGGLE_DOWNLOAD";
export const TOGGLE_THANKYOU = "LOGIN_TOGGLE_THANKYOU";
export const CHECK_LOGIN = "LOGIN_CHECK_LOGIN";
export const SUBMIT_LOGIN = "LOGIN_SUBMIT_LOGIN";
export const LOGOUT = "LOGIN_LOGOUT";
export const SUBMIT_LOGIN_FULFILLED = "LOGIN_SUBMIT_LOGIN_FULFILLED";
export const SUBMIT_LOGIN_FAILED = "LOGIN_SUBMIT_LOGIN_FAILED";
export const ACCEPT_DISCLAIMER = "LOGIN_ACCEPT_DISCLAIMER";

export type LoginState = {
    logged_in: boolean,
    logging_in: boolean,
    failed: boolean,
    show_menu: boolean,
    show_disclaimer: boolean,
    show_timeout: boolean,
    show_checkout: boolean,
    show_download: boolean,
    show_thankyou: boolean
    enable_timeout: boolean,
    username: string,
    password: string,
    rendition_type: string,
    ticket?: string,
    sbticket?: string,
    email?: string
    disclaimer?: Disclaimer,
    profile_fields: string[],
    payment_gateway?: PaymentGateway,
    paypal_gateway?: PaypalGateway,
    currency: string,
    webshop: boolean,
    enable_quick_parent: String,
    enable_community: String,
    auth: string,
    sb_url?: string
}

export interface Disclaimer {
    title: string,
    description: string
}

export interface UpdateFormAction extends Action {
    type: "LOGIN_UPDATE_FORM",
    field: "username" | "password",
    value: string
}

export interface SubmitLoginAction extends Action {
    type: "LOGIN_SUBMIT_LOGIN"
}

export interface CheckLoginAction extends Action {
    type: "LOGIN_CHECK_LOGIN"
}

export interface SubmitLogoutAction extends Action {
    type: "LOGIN_LOGOUT"
}

export interface SubmitLoginFailed extends Action {
    type: "LOGIN_SUBMIT_LOGIN_FAILED"
}

export interface SubmitLoginFulfilled extends Action {
    sb_url: string | undefined;
    type: "LOGIN_SUBMIT_LOGIN_FULFILLED",
    username: string,
    ticket: string,
    rendition_type: string,
    enable_timeout: boolean,
    profile_fields: string[],
    disclaimer?: Disclaimer,
    email?: string,
    payment_gateway?: PaymentGateway,
    paypal_gateway?: PaypalGateway,
    currency: string,
    webshop: boolean,
    enable_quick_parent: String,
    enable_community: String,
    auth: string

}

export interface ConfirmActive extends Action {
    type: "LOGIN_CONFIRM_ACTIVE"
}

export interface AcceptDisclaimer extends Action {
    type: "LOGIN_ACCEPT_DISCLAIMER"
}

export interface ToggleTimeout extends Action {
    type: "LOGIN_TOGGLE_TIMEOUT"
}

export interface ToggleCheckout extends Action {
    type: "LOGIN_TOGGLE_CHECKOUT",
    id?: string
}

export interface ToggleDownload extends Action {
    type: "LOGIN_TOGGLE_DOWNLOAD",
    id?: string
}

export interface ToggleThankyou extends Action {
    type: "LOGIN_TOGGLE_THANKYOU"
}



interface LoginResponse {
    ticket: string,
    username: string,
    email?: string,
    rendition_type: string,
    enable_timeout: boolean,
    profile_fields: string[],
    payment_gateway?: PaymentGateway,
    paypal_gateway?: PaypalGateway,
    currency: string,
    webshop: boolean,
    enable_quick_parent: String,
    enable_community: String,
}

interface Gateway {
    type: string
}

interface PaypalGateway {
    active: boolean,
    client_id: string
}

interface Westpac extends Gateway {
    active: boolean,
    type: "westpac",
    public_key: string,
    vendor: string,
}

export type PaymentGateway = Westpac;

export type LoginAction = UpdateFormAction | CheckLoginAction | SubmitLoginAction | SubmitLoginFulfilled | SubmitLoginFailed | SubmitLogoutAction | ConfirmActive | AcceptDisclaimer | ToggleTimeout | ToggleCheckout | ToggleDownload | ToggleThankyou;

const initialState: LoginState = {
    logged_in: false,
    logging_in: false,
    show_menu: true,
    show_disclaimer: true,
    show_timeout: false,
    enable_timeout: false,
    show_checkout: false,
    show_download: false,
    show_thankyou: false,
    failed: false,
    username: "",
    password: "",
    rendition_type: "original",
    profile_fields: ['sb_profileName'],
    currency: "AUD",
    webshop: false,
    enable_quick_parent: "False",
    enable_community: "False",
    auth: "",
}

export const checkLogin = (): Action => ({ type: CHECK_LOGIN });

export const getInitialState = (): LoginState => {

    let config = { ...initialState };

    if (localStorage && localStorage.getItem("T") != undefined) {
        config.ticket = localStorage.getItem("T") as string;
    }
    if (localStorage && localStorage.getItem("U") != undefined) {
        config.username = localStorage.getItem("U") as string;
    }
    if (localStorage && localStorage.getItem("E") != undefined) {
        config.email = localStorage.getItem("E") as string;
    }

    let ticketArg = location.hash.substr(1).split("|").map(filter => filter.split(":")).find(filter => filter.length == 2 && filter[0] == "ticket");

    let params = location.hash.substr(1).split("|").map(filter => filter.split("&"));

    try{
        let args = location.toString().split("#")[1].split("&");
                    args.forEach(function (v, i) {
                    if (v!=undefined) {
                        let vars = v.split(":");
                        let vname = vars[0];
                        let vvar = vars[1]

                        switch (vname) {
                            case "token":
                                config.sbticket = vvar;
                                break;
                            case "username":
                                config.username = vvar;
                                break;
                            case "email":
                                config.email = vvar;
                                break;

                        }

                    }
                });

    }
    catch {
        // console.log("ERROR getting args");
    }
    

    if (ticketArg != undefined) {
        config.ticket = ticketArg[1];
    } else {
        let sbticketArg = location.hash.substr(1).split("|").map(filter => filter.split(":")).find(filter => filter.length == 2 && filter[0] == "token");
        if (sbticketArg != undefined) {
            config.sbticket = sbticketArg[1];
        }
    }

    return config;
}

const handleLoginResponse = (response: LoginResponse) => {

    location.hash = "";

    return { type: SUBMIT_LOGIN_FULFILLED, ...response } as SubmitLoginFulfilled;
}

export const timeoutEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.pipe(debounceTime(240000),
        switchMap(action => {

            if (state$.value.login.show_timeout == false && state$.value.login.enable_timeout) {
                return observableOf({ type: TOGGLE_TIMEOUT });
            } else {
                return empty()
            }

        }))


export const checkLoginEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(CHECK_LOGIN).pipe(
        switchMap(action => {

            state$.value.login.ticket;

            let ticket = state$.value.login.ticket;
            let sbticket = state$.value.login.sbticket;

            let headers: any = {};

            let search = location.search;

            if (search != "") {
                window.history.pushState("", "", "/");
            }

            if (ticket != undefined && search == "") {
                headers["Semabench-Token"] = ticket;
                headers["SBPPortal-Ticket"] = ticket;
                headers["source"] = "portal";
                headers["user"] = state$.value.login.username;
                headers["email"] = state$.value.login.email; 
            }

            if (sbticket != undefined && search == "") {
                headers["Semabench-Token"] = sbticket;
                headers["SBPPortal-Ticket"] = sbticket;
                headers["source"] = "portal";
                headers["user"] = state$.value.login.username;
                headers["email"] = state$.value.login.email; 
            }

            return ajax.get(`api/v1/ticket${search}`, headers).pipe(
                map((response: AjaxResponse) => handleLoginResponse(response.response)),
                catchError(error => {
                    location.hash = "";
                    return observableOf({ type: LOGOUT })
                }))
        }))


export const submitLoginEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(SUBMIT_LOGIN).pipe(
        switchMap(action => {
            if (state$.value.login.logging_in == false) {
                return observableOf({ type: SUBMIT_LOGIN_FAILED } as SubmitLoginFailed);
            }


            var password = Buffer.from(state$.value.login.password).toString('base64');
            return ajax.post("api/v1/ticket", {
                name: state$.value.login.username,
                value: password,
                source: "portal"
            }, { 'Content-Type': 'application/json' }).pipe(
                map((response: AjaxResponse) => handleLoginResponse(response.response)),
                catchError((error) => {
                    return observableOf({ type: SUBMIT_LOGIN_FAILED } as SubmitLoginFailed)
                }))

        }));

export default function reducer(state = getInitialState(), action: LoginAction): LoginState {
    switch (action.type) {
        case LOGOUT:
            localStorage.clear();
            return initialState;

        case CHECK_LOGIN:
            return {
                ...state,
                logging_in: true,
                show_menu: false
            }

        case SUBMIT_LOGIN_FAILED:
            return {
                ...state,
                logged_in: false,
                logging_in: false,
                show_menu: true,
                failed: true
            }


        case SUBMIT_LOGIN_FULFILLED:

            let show_disclaimer = true;
            if (localStorage) {
                localStorage.setItem("T", action.ticket);
                localStorage.setItem("U", action.username);
                if(action.email != undefined)
                    localStorage.setItem("E", action.email);
                else
                    localStorage.removeItem("E");
                show_disclaimer = localStorage.getItem("D") != "true";
            }
            return {
                ...state,
                logged_in: true,
                logging_in: false,
                password: "",
                username: action.username,
                email: action.email,
                enable_timeout: action.enable_timeout,
                failed: false,
                show_menu: false,
                ticket: action.ticket,
                rendition_type: encodeURIComponent(action.rendition_type),
                disclaimer: action.disclaimer,
                show_disclaimer,
                profile_fields: action.profile_fields,
                payment_gateway: action.payment_gateway,
                paypal_gateway: action.paypal_gateway,
                currency: action.currency,
                webshop: action.webshop,
                enable_quick_parent: action.enable_quick_parent,
                enable_community: action.enable_community,
                auth: action.auth,
                sb_url: action.sb_url
            }

        case ACCEPT_DISCLAIMER: {

            if (localStorage) {
                localStorage.setItem("D", "true");
            }

            return {
                ...state,
                show_disclaimer: false
            }

        }

        case SUBMIT_LOGIN:
            if (state.username != "" && state.password != "") {

                return {
                    ...state,
                    logging_in: true,
                    failed: false
                };
            } else {
                return state;
            }

        case UPDATE_FORM:
            return {
                ...state,
                [action.field]: action.value,
                failed: false
            }

        case TOGGLE_TIMEOUT:
            return {
                ...state,
                show_timeout: !state.show_timeout
            }

        case TOGGLE_CHECKOUT:
            return {
                ...state,
                show_checkout: !state.show_checkout
            }

        case TOGGLE_DOWNLOAD:
            return {
                ...state,
                show_download: !state.show_download
            }

        case TOGGLE_THANKYOU:
            return {
                ...state,
                show_thankyou: !state.show_thankyou
            }

        default:
            return state;
    }
}